<template>
  <div class="modal-body-content">
    <div class="modal-body-list-box">
      <div class="search-box-in-title">
        <h2>{{ $t('geofence') }} {{ $t('list') }}</h2>
        <div>
          <input v-model="search" :placeholder="$t('insert_search_query')" />
          <button type="button" @click.stop="showSmallModal = true" class="action-button">{{ $t('create_new') }}</button>
        </div>
      </div>
      <table>
        <thead>
          <tr>
            <th class="w25p" @click="toggleSort('geofence', 'geofence_name')">
              {{ $t('geofence') }} {{ $t('name') }}
              <span v-if="sortStates.geofence.find(col => col.id === 'geofence_name').order">
                <img v-if="sortStates.geofence.find(col => col.id === 'geofence_name').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
              </span>
              <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
            </th>
            <th class="w10p" style="cursor: not-allowed;">{{ $t('manage') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="polygon in paginatedData" :key="polygon.geofence_id" :style="polygon.is_deleted ? { background: '#EBEBEB' } : {}">
            <td :title="polygon.geofence_name" class="w25p" @click.stop="editPolygon(polygon)">
              {{ polygon.geofence_name }}
            </td>
            <td class="w10p" v-if="!polygon.is_deleted">
              <img @click.stop="editPolygon(polygon)" src="@/assets/images/edit.svg" :title="'수정'"/>
              <img @click.stop="deleteCoordinates(polygon.geofence_id)" src="@/assets/images/delete.svg" :title="'삭제'"/>
            </td>
            <td class="w10p" v-else>
              <img @click.stop="deleteCoordinates(polygon.geofence_id, false)" src="@/assets/images/restore.svg" :title="'복원'"/>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 페이지네이션 -->
      <div class="pagination-control">
        <div>
          <img src="@/assets/images/double_arrow_left_gray.svg" @click.stop="prevPagePer" v-show="currentPage !== 1"/>
          <img src="@/assets/images/arrow_left_gray.svg" @click.stop="prevPage" v-show="currentPage !== 1"/>
        </div>
        <span v-for="page in currentPageRange" :key="page" @click.stop="currentPage = page" :class="{ selected: currentPage === page }" :style="currentPage === page ? {cursor: 'default'} : {}">{{ page }}</span>
        <div>
          <img src="@/assets/images/arrow_right_gray.svg" @click.stop="nextPage" v-show="(currentPage !== totalPages) && totalPages !== 0"/>
            <img src="@/assets/images/double_arrow_right_gray.svg" @click.stop="nextPagePer" v-show="(currentPage !== totalPages) && totalPages !== 0"/>
        </div>
      </div>
    </div>

    <!-- #region 영역 개별 관리 모달 -->
    <div v-show="showSmallModal" class="modal-body-content-modal-background" @click.stop="">
      <div class="modal-body-content-modal">
        <div class="modal-body-edit-box">
          <div class="modal-body-edit-box-title">
            <h2>{{ nowGFID ? $t('modify_geofence') : $t('add_geofence') }}</h2>
            <img src="@/assets/images/x_black.svg" @click.stop="resetPins(true)"/>
          </div>
          <div class="modal-body-edit-box-content">
            <div class="modal-body-edit-box-content-main">
              <table>
                <tbody>
                  <tr>
                    <th>{{ $t('geofence') }} {{ $t('name') }}</th>
                    <td><input v-model="polygonName" :placeholder="$t('enter_your_geofence_name')" required /></td>
                  </tr>
                  <tr v-show="isShowRadius">
                    <th>{{ $t('set_radius') }} (m)</th>
                    <td><input v-show="isShowRadius" type="number" v-model="radius"/></td>
                  </tr>
                  <tr>
                    <th>{{ $t('pin_counter') }}</th>
                    <td>{{ pinCounter - 1 }}</td>
                  </tr>
                  <tr>
                    <th>{{ $t('area_size') }}</th>
                    <td>{{ polygonArea }} m²</td>
                  </tr>
                </tbody>
              </table>
              <div id="geoMap">
                <div class="map-button-gruop" style="top: 10px; right: 10px;">
                  <button @click.stop="geoMap.zoomIn()" :disabled="geoMap && nowZoomLevel === geoMap.getMaxZoom()"><img src="../assets/images/plus.svg" /></button>
                  <button @click.stop="geoMap.zoomOut()" :disabled="geoMap && nowZoomLevel === geoMap.getMinZoom()"><img src="../assets/images/minuse.svg" /></button>
                  <button @click.stop="resetPins()" :disabled="pinCounter <= 1">
                    <img :src="require('@/assets/images/broom-black.svg')" />
                  </button>
                </div>
              </div>
              <div class="button-group">
                <button type="button" @click.stop="resetPins(true)" class="cancel-button">{{ $t('cancel') }}</button>
                <button v-if="nowSelectedGeofence && nowSelectedGeofence && !nowSelectedGeofence.is_deleted" type="button" @click.stop="deleteCoordinates(nowGFID)" class="delete-button" v-show="nowGFID">{{ $t('delete') }}</button>
                <button v-else-if="nowSelectedGeofence && nowSelectedGeofence && nowSelectedGeofence.is_deleted" type="button" @click.stop="deleteCoordinates(nowGFID, false)" class="retrieve-button">{{ $t('restore') }}</button>
                <button type="button" @click.stop="saveCoordinates()" class="action-button" :disabled="!isCanSave">{{ $t('submit') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- #endregion -->
  </div>
</template>

<script setup>
import { ref, onMounted, watch, computed, nextTick } from 'vue';
import L from 'leaflet';
import * as turf from "@turf/turf";
import { SERVER_REQUEST, GET_SERVER_REQUEST, geofence_list } from '../utils/ServerConnect';
import { CalculateCircleBoundary, defaultLocation, defaultZoomLevel, firstMapSetting, numberAndCloseMarker } from '../utils/MapSetting';
import { getIsMobile, SendErrorLog } from '@/utils/GlobalUtility';
import { showNotification } from '@/utils/Notification';
import { loadingStore } from '@/utils/LoadingStore';
import { sortedGFList, sortStates, toggleSort } from '@/utils/SortUtility';
import { showSmallModal } from '@/utils/ModalUtility';

const geoMap = ref(null);
let polygonLayer;
const pins = ref([]);
const pinCounter = ref(1); // 핀 번호 관리
const radius = ref(100); // 기본값 설정
const nowSelectedGeofence = ref(null)
const nowGFID = ref(null);
const polygonName = ref("");
const latlngList = ref([]); // 저장된 좌표 조회, 지도 화면 맞춤시 사용
const isShowRadius = ref(true);  // 반경 입력칸 visible 컨트롤을 위함
const nowZoomLevel = ref(18);
const isCanSave = ref(false);

onMounted(async () => {
  await nextTick(async () => {
    showSmallModal.value = true;
    geoMap.value = await firstMapSetting('geoMap', defaultZoomLevel.value);
  
    // 지도 클릭 이벤트
    geoMap.value.on('click', function (e) {
      if (geoMap.value) {
        addPin(e.latlng); // map이 존재할 때만 마커 추가
      }
    });
    geoMap.value.on("zoomend", () => {
      nowZoomLevel.value = geoMap.value.getZoom();
    });

    retrievePolygons();
    showSmallModal.value = false;

    loadingStore.hideLoading();
    geoMap.value.invalidateSize();
  })
});

watch([pinCounter], () => {
  if (pinCounter.value < 3) isShowRadius.value = true;
  else isShowRadius.value = false;
});

watch([radius], () => {
  if (isShowRadius.value) {
    drawPolygon();
  }
});

watch([polygonName, pinCounter, radius], () => {
  if (!nowGFID.value) {
    if (polygonName.value && pinCounter.value > 1 && pinCounter.value !== 3) isCanSave.value = true;
    else isCanSave.value = false;
  } else {
    if (polygonName.value && pinCounter.value > 1 && pinCounter.value !== 3
      && (originalName.value !== polygonName.value
      || JSON.stringify(originalData.value) !== JSON.stringify(polygonData.value))
    ) isCanSave.value = true;
    else isCanSave.value = false;
  }
});

// 핀 추가 및 폴리곤 업데이트
const addPin = (latlng, isremoved = false) => {
  if (!geoMap.value) return; // 지도가 초기화되지 않았을 경우 추가 방지

  const customIcon = numberAndCloseMarker(pinCounter.value);

  const marker = L.marker(latlng, { icon: customIcon, lat: latlng.lat, lng: latlng.lng, type: 'numberPin', draggable: true, number: pinCounter.value }).addTo(geoMap.value);

  const closeBtn = marker.getElement().querySelector('button');
  // 드래그 방지: 마커 드래그 이벤트로 전달되지 않도록
  closeBtn.addEventListener('mousedown', (e) => e.stopPropagation());
  closeBtn.addEventListener('touchstart', (e) => e.stopPropagation(), { passive: true });
  // 'X' 버튼 클릭 시 마커 삭제
  closeBtn.addEventListener('click', (e) => {
    e.stopPropagation(); // 클릭 이벤트 전파 방지 (지도 클릭으로 인식되는 것 방지)
    removeMarker(marker);
  });

  // 드래그가 끝났을 때 폴리곤 다시 생성
  marker.on('dragend', (event) => {
    const { lat, lng } = event.target.getLatLng()
    const { number } = event.target.options
    pins.value.forEach(p => p.options.number === number ? (p.options.lat = lat, p.options.lng = lng, p.setLatLng(event.target.getLatLng())) : "")
    drawPolygon();
  })

  if (!isremoved) {
    pins.value.push(marker);
    drawPolygon(); // 폴리곤 생성
  }
  
  pinCounter.value++; // 핀 번호 증가
};

// 마커 삭제 함수
const removeMarker = (marker) => {
  if (!geoMap.value) return; // 지도가 초기화되지 않았을 경우 추가 방지

  geoMap.value.eachLayer(layer => (layer.options.type === 'numberPin' || layer.options.type === 'polygon') ? geoMap.value.removeLayer(layer) : ""); // 지도에서 전체 마커 제거
  pins.value = pins.value.filter(m => m.options.lat !== marker.options.lat || m.options.lng !== marker.options.lng); // 리스트에서 해당 마커 제거
  pinCounter.value = 1; // 핀 번호 초기화
  pins.value.forEach(e => addPin({lat: e.options.lat, lng: e.options.lng}, true)); // 지도에 전체 마커 재생성
  // 폴리곤 다시 생성
  drawPolygon();
};
// 폴리곤 생성 함수
const drawPolygon = (radi = -1) => {
  if (polygonLayer) geoMap.value.removeLayer(polygonLayer); // 기존 폴리곤이 있다면 삭제
  
  const latlngs = pins.value.map(m => m.getLatLng()); // 남아있는 마커들의 좌표 가져오기
  
  if (latlngs.length > 2) polygonLayer = L.polygon(latlngs, { color: 'blue', type: "polygon" }).addTo(geoMap.value);  // 3개 이상의 마커가 있을 때만 폴리곤을 그림
  if (latlngs.length === 1) polygonLayer = L.circle(latlngs[0], { radius: radi == -1 ? radius.value : radi, color: 'blue', fillOpacity: 0.2, type: "polygon" }).addTo(geoMap.value); // 1개 일경우 원
};

// 핀과 다각형 초기화
const resetPins = (isModalClose = false) => {
  nowSelectedGeofence.value = nowGFID.value = polygonName.value = null;
  originalName.value = originalData.value = null;
  geoMap.value.eachLayer(layer => (layer.options.type === 'numberPin' || layer.options.type === 'polygon') ? geoMap.value.removeLayer(layer) : "");

  pins.value = [];
  pinCounter.value = 1;
  radius.value = 100;
  if(isModalClose) showSmallModal.value = false;

  geoMap.value.setView(defaultLocation.value, defaultZoomLevel.value);
};

const polygonLetLngs = computed(() => {
  const coords = [];
  pins.value.forEach(pin => {
    const latLng = pin.getLatLng();
    coords.push({
      lat: latLng.lat,
      lng: latLng.lng
    });
  });
  return coords;
});
const polygonData = computed(() => {
  return {
    type: polygonLetLngs.value.length > 1 ? "polygon" : "circle#" + radius.value,
    locations: polygonLetLngs.value
  }
});
// GeoFence 저장
const saveCoordinates = async () => {
  try {
    if (pins.value.length < 1) return;
    // if (pins.value.length == 2) return;
    if (!polygonName.value) {
      showNotification('Enter polygon name.', 'warn', 'top-center');
      return;
    }
    const totalData = {
      ...(nowGFID.value ? { geofence_id: nowGFID.value } : {}),
      ...(originalName.value !== polygonName.value ? { geofence_name: polygonName.value } : {}),
      ...(JSON.stringify(originalData.value) !== JSON.stringify(polygonData.value) ? { data: polygonData.value } : {}),
    }
    const jsonData = JSON.stringify(totalData);
    await SERVER_REQUEST('geofence', nowGFID.value ? 'PUT' : 'POST', jsonData);
    retrievePolygons();
    resetPins(true);
    
    // SendErrorLog('C301', { name: 'Save success',
    //                         message: `GeoFence Name : ${totalData.name}`,
    //                         stack: totalData.name,});
  } catch (error) {
    SendErrorLog('GeoFence', error);
  }
};

// GeoFence 조회
const retrievePolygons = async () => {
  loadingStore.showLoading();
  try {
    geofence_list.value = await GET_SERVER_REQUEST('geofence');
  } catch (error) {
    SendErrorLog('GeoFence', error);
  }
  loadingStore.hideLoading();
};

// GeoFence 삭제 및 복구
const deleteCoordinates = async (gf_id, isDelete = true) => {
  loadingStore.showLoading();
  try {
    const totalData_Delete = {
      geofence_id: gf_id
    }
    const totalData_Restore = {
      geofence_id: gf_id,
      undelete: true
    }
    const jsonData = JSON.stringify(isDelete ? totalData_Delete : totalData_Restore);

    await SERVER_REQUEST('geofence', 'DELETE', jsonData);
    loadingStore.hideLoading();

    polygonName.value = null;
    retrievePolygons();
    resetPins(true);

    // SendErrorLog('C301', { name: isDelete ? 'Delete success' : 'Restore Success',
    //                        message: `GeoFence ID : ${gf_id}`,
    //                        stack: gf_id,});

  } catch (error) {
    console.error('Error ' + ( isDelete ? 'deleting' : 'restoring' ) + ' item:', error);
    SendErrorLog('GeoFence', error);
  }
};

const originalName = ref(null);
const originalData = ref(null);
// 조회된 GeoFence 선택 시 지도에 표시해 줌
const editPolygon = (polygon) => {
  if (nowGFID.value === polygon.geofence_id) return resetPins();
  loadingStore.showLoading();
  try {
    resetPins();
    showSmallModal.value = true;
    const polygonCoords = polygon.data;
    nowSelectedGeofence.value = polygon;
    nowGFID.value = polygon.geofence_id;

    polygonName.value = originalName.value = polygon.geofence_name;
    originalData.value = polygon.data;
    polygonCoords.locations.forEach(coord => {
      const latLng = L.latLng(coord.lat, coord.lng);
      addPin(latLng);
      latlngList.value.push(latLng);
    });
    if (polygonCoords.type.includes("circle")) {
      radius.value = polygonCoords.type.substr(polygonCoords.type.indexOf('#') + 1);
      drawPolygon(radius.value);

      // 원에 맞춰서 지도 보여주기
      const bounds = CalculateCircleBoundary(latlngList.value[0].lat, latlngList.value[0].lng, radius.value);
      geoMap.value.fitBounds(bounds, { padding: [20, 20] }); // 약간의 여백 추가
    }
    else {
      drawPolygon();
      geoMap.value.fitBounds(latlngList.value);
    }

    latlngList.value = ([]);
  } catch (error) {
    SendErrorLog('GeoFence', error);
  }
  loadingStore.hideLoading();
};

const calculateArea = () => {
  if (pins.value.length === 1) return (Math.PI * Math.pow(radius.value, 2)).toFixed(2); // πr² 계산 후 소수점 2자리
  if (pins.value.length < 3) return 0;
  const polygonCoords = [];
  pins.value.forEach(pin => {
    const latLng = pin.getLatLng();
    polygonCoords.push([
      latLng.lat,
      latLng.lng
    ]);
  });
  const firstAndLast = pins.value[0].getLatLng();
  polygonCoords.push([firstAndLast.lat, firstAndLast.lng]);
  const poly = turf.polygon([polygonCoords])  // Turf.js 폴리곤 객체 생성
  const area = turf.area(poly); // 면적 계산 (㎡ 단위)
  return area.toFixed(2); // 소수점 2자리
};
const polygonArea = computed(() => calculateArea());

const currentPage = ref(1);
const itemsPerPage = ref(10);
const showOncePage = computed(() => { return (getIsMobile() ? 5 : 10) });
// 페이지네이션된 데이터 계산
const totalPages = computed(() =>
  Math.ceil(filteredList.value.length / itemsPerPage.value)
);
const paginatedData = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value;
  return filteredList.value.slice(start, start + itemsPerPage.value);
});
const minPageRange = computed(() => {
  if (currentPage.value % showOncePage.value === 0) return currentPage.value - (showOncePage.value - 1);
  else return currentPage.value - ((currentPage.value % showOncePage.value) - 1);
});
const maxPageRange = computed(() => {
  let num = minPageRange.value + (showOncePage.value - 1);
  if (num > totalPages.value) num = totalPages.value
  return num;
});
const currentPageRange = computed(() => {
  const range = []
  for (let i = minPageRange.value; i <= maxPageRange.value; i++) {
    range.push(i)
  }
  return range;
});
// 페이지네이션 함수
const prevPage = () => {
  if (currentPage.value > 1) currentPage.value--;
};
const prevPagePer = () => {
  const num = Math.floor(currentPage.value / showOncePage.value);
  if (num < 1) currentPage.value = 1;
  else currentPage.value = ((num - 1) * showOncePage.value) + 1;
};
const nextPage = () => {
  if (currentPage.value < totalPages.value) currentPage.value++;
};
const nextPagePer = () => {
  const num = Math.floor(currentPage.value / showOncePage.value);
  const check = ((num + 1) * showOncePage.value) + 1
  if (check > totalPages.value) currentPage.value = totalPages.value;
  else currentPage.value = check;
};

const search = ref("");
const filteredList = computed(() => {
  const query = search.value.trim().toLowerCase(); // 공백 제거 & 소문자 변환

  return sortedGFList.value.filter(polygon =>
    String(polygon.geofence_name).toLowerCase().includes(query) // 이름으로 검색
  );
});

// 현재 보고있는 페이지를 전체 페이지수에 맞춰 자동으로 바꿔줌
watch(
  () => filteredList.value.length,
  () => {
    const newTotalPages = Math.ceil(filteredList.value.length / itemsPerPage.value);
    if (currentPage.value > newTotalPages) {
      currentPage.value = newTotalPages || 1; // 0일 때도 대비
    }
  }
);
</script>